export default __webpack_public_path__ + "static/media/inner12.eae77567.jpg";